import pino from 'pino';

export type LogSeverity = 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR' | 'CRITICAL';

// Map to stackdriver log severities
// See: https://cloud.google.com/logging/docs/reference/v2/rest/v2/LogEntry#LogSeverity
const severities: Record<string, LogSeverity> = {
  trace: 'DEBUG',
  debug: 'DEBUG',
  info: 'INFO',
  warn: 'WARNING',
  error: 'ERROR',
  fatal: 'CRITICAL',
};

export const logger = pino({
  messageKey: 'message',
  formatters: {
    bindings: () => ({}), // prevents `hostname` and `pid` properties from being logged
    level(label, number) {
      return {
        severity: severities[label] ?? 'DEBUG',
        level: number,
      };
    },
  },
});
